<template>
  <div class="content">
    <h2 class="font-light">Record Index</h2>
    <server-error v-bind:error="error.serverError"></server-error>
    <div class="row">
      <search-field
        v-bind:search="filters.search"
        @handleSearch="handleSearch"
      ></search-field>
      <div class="col-4">
        <div class="form-group u-inline-flex u-pull-right">
          <filter-dropdown
            v-bind:options="filterOptions"
            v-on:handle-filter="handleFilter"
          ></filter-dropdown>
          <!-- New record button -->
          <router-link
            v-if="permissions.includes('records.add_record')"
            :to="{ name: 'record-create' }"
          >
            <button id="addButton" class="btn-info action-button">
              <span class="icon">
                <i
                  class="fa-wrapper fa fa-plus-circle normal-icon"
                  aria-hidden="true"
                ></i>
              </span>
              <span>New</span>
            </button>
          </router-link>
        </div>
      </div>
      <filter-tags v-bind:filterOptions="filterOptions"></filter-tags>
    </div>
    <record-table v-bind:records="recordsList"></record-table>
    <div class="row">
      <pagination-links
        v-if="pages.recordList"
        v-bind:pages="pages.recordList"
        @handlePage="handlePage"
      ></pagination-links>
      <page-size-selector
        v-on:handle-page-size="handlePageSize()"
      ></page-size-selector>
    </div>
  </div>
</template>
<style></style>
<script>
import { mapGetters } from "vuex";
import RecordTable from "@/components/records/RecordTable";
import ServerError from "@/components/ServerError";
import SearchField from "@/components/SearchField";
import FilterDropdown from "@/components/FilterDropdown";
import FilterTags from "@/components/FilterTags";
import PaginationLinks from "@/components/Pagination";
import PageSizeSelector from "@/components/PageSizeSelector";

import { debounce } from "@/functions/debounce.function";

import { SetupFilters } from "@/services/filters.service";
import { GetSelectedFilters } from "@/services/filters.service";
import { HandleAllFilters } from "@/services/filters.service";
import { QueryHasChanged } from "@/services/filters.service";

export default {
  name: "record-index",
  components: {
    RecordTable,
    SearchField,
    FilterDropdown,
    FilterTags,
    PaginationLinks,
    PageSizeSelector,
    ServerError
  },
  data: function() {
    return {
      filterOptions: {
        result: [],
        is_active: [
          { name: "True", value: "true", selected: false },
          { name: "False", value: "false", selected: false }
        ],
        is_closed: [
          { name: "True", value: "true", selected: false },
          { name: "False", value: "false", selected: false }
        ]
      }
    };
  },
  computed: {
    ...mapGetters("records", ["search", "filters", "recordsList", "pages"]),
    ...mapGetters("core", ["results", "error"]),
    ...mapGetters("auth", ["userProfile", "permissions"])
  },
  watch: {
    search: debounce(function() {
      // This watches the filters.search model to debounce the input =)
      this.$store.dispatch("records/getRecords");
      this.$router.replace({
        name: "record-index",
        query: { ...this.filters }
      });
    }, 300),
    results: function() {
      this.setupResultFilter();
    }
  },
  methods: {
    handleSearch(searchVal) {
      this.$store.commit("records/filters", {
        search: searchVal,
        page: ""
      });
    },
    handlePage(newPage) {
      if (newPage == 1) {
        newPage = "";
      }
      this.$store.commit("records/filters", { page: newPage });
      this.$store.dispatch("records/getRecords");
      if (QueryHasChanged(this.$route.query, this.filters)) {
        this.$router.replace({
          name: "record-index",
          query: { ...this.filters }
        });
      }
    },
    handlePageSize() {
      // Refresh the array by going to page 1 when the pageSize is changed
      this.handlePage(1);
    },
    handleFilter(payload) {
      HandleAllFilters(this.filters, this.filterOptions, payload);
      // Reset the page to 0 as we don't know how many pages to expect!
      payload.page = "";
      this.$store.commit("records/filters", payload);
      this.$store.dispatch("records/getRecords");
      this.$router.replace({
        name: "record-index",
        query: { ...this.filters }
      });
    },
    setupResultFilter() {
      // This function sets up the topics in the filterOptions Object whenever
      // the results received from the server change.
      var stack = [];
      for (let result of this.results.filter(i => i.namespace == "records")) {
        var entry = {};
        entry["name"] = result.name;
        entry["value"] = result.name;
        entry["selected"] = false;
        stack.push(entry);
      }
      this.filterOptions["result"] = stack;
    }
  },
  mounted() {
    // Re-hydrate the filter with either the URL query params or values from
    // the Vuex store.
    SetupFilters(this, "records/filters", "record-index");
    this.setupResultFilter();
    for (let key in this.$route.query) {
      GetSelectedFilters(this.filterOptions[key], this.$route.query[key]);
    }
    // If there are *Still* no filters selected then set 'is_active' as the
    // default filter.
    if (Object.keys(this.filters).length == 0) {
      this.handleFilter({ is_active: "true" });
    }
    // Initialize other bits
    this.$store.commit("core/clearErrors");
    this.$store.dispatch("records/getRecords");
  }
};
</script>
